















































































































import { Vue, Watch, Component, Prop } from 'vue-property-decorator'

import EditLink from '@/components/lfs/Badges/ModalItems/EditLink.vue'
import EditContact from '@/components/lfs/Badges/ModalItems/EditContact.vue'
import EditMain from '@/components/lfs/Badges/ModalItems/EditMain.vue'

import { ServerHelper } from '@/utils/ServerHelpers'
import { ServerBadge } from '@/utils/ServerBadge'
import { Badge } from '@/store/modules/lib'
import {namespace} from "vuex-class"

const roistat = namespace('roistat')
const profile = namespace("profile")
const resources = namespace("resources")

@Component({
  name: 'c-badge-edit-modal',

  components: {
    EditLink,
    EditContact,
    EditMain
  },

  model: {
    prop: 'isOpen',
    event: 'input'
  }
})
export default class BadgeEditModal extends Vue {
  @roistat.Action('sendEvent') protected sendEvent:any
  @profile.State("userCompany") protected userCompany: any
  @profile.Mutation('changeContacts') protected changeContacts: any
  @resources.Action('getCountryFromServer') protected getCountryFromServer: any
  @profile.Getter('profile') protected currentBadge:any
  @Prop(Boolean) isOpen!: boolean
  @Prop(Boolean) isProfileInfo!: boolean

  editBadgeDlgTab: string = 'tab-1'
  deleteBadgeItem: any[] = []

  @Watch('isOpen')
  reset() {
    if(!this.isOpen) this.editBadgeDlgTab = 'tab-1'
  }

  async beforeMount(){
    this.getCountryFromServer()
  }

  async onSubmit() {
    const badge: Badge = this.currentBadge
    const contacts = badge.contacts.map((contact, i) => {
      contact.order = i + 1

      return contact
    })

    badge.contacts = contacts

    //правим "О себе"
    await ServerBadge.update(badge)

    //правим и добавляем "Контакты"
    badge.contacts.forEach(contact => {
      if(contact.type == 'address') {
        ServerBadge.addAddress(badge.id, contact)
      } else {
        if(contact.id) {
          ServerBadge.editContact(badge.id, contact.id, contact)
        } else {
          ServerBadge.addContact(badge.id, contact)
        }
      }
    })

    //правим адрес
    badge.locations.forEach(location => {
      ServerBadge.editAddress(badge.id, location)
    })

    let resplink:any = true;
    //добавляем "Ссылки"
    if(Array.isArray(badge.promo)){
      badge.promo.forEach(promo => {
        if(promo.type == 'link') {
          if(!promo.id) {
            resplink =  ServerBadge.addPromo(badge.id, promo)
          }
        }
      })
    }

    let resp;
    //Удаляем
    this.deleteBadgeItem.forEach(item => {

      if (item.type == 'link') {
        resp = ServerBadge.deletePromo(badge.id, item.id)
      } else if (item.type == 'contacts') {
        resp =ServerBadge.deleteContact(badge.id, item.id)
      } else if (item.type == "address") {
        resp =ServerBadge.deleteAddress(badge.id, item.id)
      }
    })
    Promise.all([resp, resplink]).then(()=>{
      ServerBadge.getBadgeById(badge.id)
        .then((res: any) => {
          this.$store.commit('profile/addBadgeById', res.data.Badge)
          this.onClose()
          let params = [
            {
              "name": this.isProfileInfo ? "“Профиль”: Переход в “Редактирование бейджа” в блоке Бейджи, изменения сохранены" : "“Стендисты”: Переход в “Редактирование бейджа” изменения сохранены",
              "data": {
                "company": this.userCompany.title
              }
            }
          ]
          this.sendEvent(params)
        })
    })
    //получаем бадж с новыми данными и сохраняем в store
  }

  onDelete(val: any) {
    if(val.type === 'link') {
      let payload = {
        id: this.currentBadge.id,
        contacts: this.currentBadge.contacts,
        promo: this.currentBadge.promo.filter((item:any) => item != val.item),
        locations: this.currentBadge.locations,
        isCurrentCompany: false
      }
      this.changeContacts(payload)
    }

    if(val.type == 'contacts') {
      let payload = {
        id: this.currentBadge.id,
        contacts: this.currentBadge.contacts.filter((item:any) => item != val.item),
        promo: this.currentBadge.promo,
        locations: this.currentBadge.locations,
        isCurrentCompany: false
      }
      this.changeContacts(payload)
    }

    if(val.type == 'address') {
      let payload = {
        id: this.currentBadge.id,
        contacts: this.currentBadge.contacts,
        promo: this.currentBadge.promo,
        locations: this.currentBadge.locations.filter((item:any) => item != val.item),
        isCurrentCompany: false
      }
      this.changeContacts(payload)
    }

    if(val.item.id) {
      this.deleteBadgeItem.push({ id: val.item.id, type: val.type })
    }

  }

  onClose() {
    this.deleteBadgeItem = []
    this.$emit('input', false)
  }
}
